<template>
  <div class="this-page">
    <template>
      <el-button type="primary" style="margin-bottom: 20px;" @click="openAdd()">添加代理商</el-button>

    </template>
    <template>
      <el-table :data="list" stripe style="width: 100%" size="small" :height="tableHeight"  border>
        <el-table-column prop="id" label="代理商ID" width="100" fixed>
        </el-table-column>
        <el-table-column prop="uid" label="会员ID" min-width="150">
        </el-table-column>
        <el-table-column prop="name" label="代理商名称" min-width="150">
        </el-table-column>
        <el-table-column prop="invited_number" label="累计邀请人数" min-width="150">
        </el-table-column>
        <el-table-column prop="order_number" label="累计关联订单" min-width="150">
        </el-table-column>
        <el-table-column prop="order_amount" label="累计业绩流水" min-width="150">
        </el-table-column>
        <el-table-column prop="created_at" label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == 0 ? 'danger':'success'" size="small"> {{scope.row.status == 0 ?'停用':'有效'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="加入时间" width="180">
        </el-table-column>
        <el-table-column prop="created_at" label="操作" width="325" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" plain round @click="deleted(scope.row.id)">删除</el-button>
            <el-button type="warning" size="mini" plain round @click="updateField(scope.row.id,scope.row.status == 0 ?'启用代理商':'停用代理商',scope.row.status == 0 ?'启用代理商后，代理商可在公众号个人中心看到代理商入口':'停用代理商后，代理商入口将关闭','status',scope.row.status == 0 ?1:0)">{{scope.row.status == 0 ?'启用':'停用'}}</el-button>
            <el-button type="primary" size="mini" plain round @click="showDetail(scope.row.id)">流水明细</el-button>
            <el-button type="primary" size="mini" plain round @click="showCustomer(scope.row.id)">客户明细</el-button>
          </template>
        </el-table-column>

      </el-table>
      <template>
        <el-pagination style="margin-top:20px" :current-page="page" background layout="prev, pager, next" :page-count="pageCount"
                       @current-change="pageChange">
        </el-pagination>
      </template>
    </template>
    <template>
      <el-dialog title="添加代理商" :visible.sync="showAdd" width="400px">
        <el-form :model="add">
          <el-form-item label="名称" :label-width="formLabelWidth">
            <el-input v-model="add.name" autocomplete="off" placeholder="代理商名称" ></el-input>
          </el-form-item>
          <el-form-item label="会员ID" :label-width="formLabelWidth">
            <el-input v-model="add.uid" autocomplete="off" placeholder="请输入绑定会员号" type="number"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showAdd = false">取 消</el-button>
          <el-button type="primary" @click="addPartner()">确 定</el-button>
        </div>
      </el-dialog>
    </template>
    <el-dialog title="代理商流水明细" :visible.sync="detailShow">
      <el-date-picker
          @change="timeChange"
          v-model="detailTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
      </el-date-picker>
      <el-table :data="detailResult"  show-summary>
        <el-table-column property="uid" label="会员号" width="80"></el-table-column>
        <el-table-column property="no" label="单号" width="180"></el-table-column>


        <el-table-column property="volume" label="客户体积"></el-table-column>
        <el-table-column property="realVolume" label="实际体积"></el-table-column>
        <el-table-column property="mergePackage" label="合包数量"></el-table-column>
        <el-table-column property="payTime" label="支付时间"></el-table-column>
      </el-table>
      <template>
        <el-pagination style="margin-top:20px" :current-page="detailPage" background layout="prev, pager, next" :page-count="detailPageCount"
                       @current-change="pageDetailChange">
        </el-pagination>
      </template>
    </el-dialog>
    <el-dialog title="客户明细" :visible.sync="customerShow" width="500px">
      <el-table :data="customerResult" >
        <el-table-column property="id" label="会员号" width="80"></el-table-column>
        <el-table-column property="name" label="昵称" width="180"></el-table-column>
        <el-table-column property="created_at" label="邀请时间"></el-table-column>
      </el-table>
      <template>
        <el-pagination style="margin-top:20px" :current-page="customerPage" background layout="prev, pager, next" :page-count="customerPageCount"
                       @current-change="pageCustomerChange">
        </el-pagination>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import toolBar from '../../components/tool-bar/index.vue'
export default {
  components:{
    toolBar
  },
  data() {
    return {
      tableHeight: document.documentElement.clientHeight - 165 + 'px',
      load: {
        list: false
      },
      page: 1,
      searchValue:'',
      pageCount: 1,
      list: [],
      showAdd:false,
      formLabelWidth:'80px',
      add:{
        name:'',
        uid:''
      },
      detailId:'',
      detailResult:[],
      detailShow:false,
      detailPage:1,
      detailPageCount:1,
      detailTime:[],
      customerId:'',
      customerResult:[],
      customerShow:false,
      customerPage:1,
      customerPageCount:1,
    }
  },
  mounted() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;

        that.tableHeight = window.fullHeight - 165 + 'px';  // 高

      })()
    };
    this.getList()
  },
  methods: {
    openAdd(){
      this.add.name = ''
      this.add.uid = ''
      this.showAdd = true
    },
    addPartner(){
      this.showAdd = false
      this.$fetch.post('Partner/addPartner', this.add, true).then(res => {
        this.page = 1
        this.getList()
      })
    },
    getList() {
      this.$fetch.post('Partner/getList', {
        page: this.page,
        search:this.searchValue
      }, true).then(res => {
        this.load.list = true
        this.list = res.result
        this.pageCount = res.page
      })
    },
    pageChange(e) {
      this.page = e
      this.getList()
    },
    pageDetailChange(e){
      this.detailPage = e
      this.getDetailList()
    },
    searchOrder(e){
      if(!e){
        this.$message({
          type: 'info',
          message: '当前没有搜索任何信息'
        });
        return false
      }
      this.searchValue = e
      this.page = 1
      this.getList()

    },
    clearSearch(){
      console.log('清空搜索')
      this.searchValue = ''
      this.page = 1
      this.getList()
    },
    deleted(id){
      this.$confirm('确定要删除代理商吗', '删除代理商', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        this.$fetch.post('Partner/deletePartner', {
          id: id
        }, true).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.page = 1
          this.getList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        });
      });
    },
    adopt(id,owner){
      this.$fetch.post('Group/adoptCreateApply', {
        id: id,
        owner:owner
      }, true).then(res => {
        this.page = 1
        this.getList()
      })
    },
    sendCoupon(id) {
      this.$prompt('请输入起止会员号：格式：10001,10002', '批量发放优惠券', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType:'text'
      }).then(({ value }) => {
        this.$fetch.post('User/sendCouponBatch', {
          id: id,
          value:value
        }, true).then(res => {
          this.$message({
            type: 'success',
            message: '批量发放成功'
          });

        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        });
      });
    },
    updateField(id,title,message,field,value){
      this.$confirm(message, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ valued }) => {
        this.$fetch.post('Partner/updateField', {
          id: id,
          field,
          value
        }, true).then(res => {
          this.$message({
            type: 'success',
            message: '操作成功'
          });
          this.getList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消操作'
        });
      });
    },
    showDetail(id){
      this.detailId = id
      this.detailResult = []
      this.detailShow = true
      this.getDetailList()
    },
    getDetailList(){
      this.$fetch.post('Partner/getDetailList', {
        page: this.detailPage,
        id:this.detailId,
        time:this.detailTime
      }, true).then(res => {
        this.detailResult = res.result
        this.detailPageCount = res.page
      })
    },
    showCustomer(id){
      this.customerId = id
      this.customerResult = []
      this.$fetch.post('Partner/getCustomers', {
        page: this.customerPage,
        id:this.customerId,
      }, true).then(res => {
        this.customerShow = true
        this.customerResult = res.result
        this.customerPageCount = res.page
      })

    },
    pageCustomerChange(e){
      this.customerPage= e
      this.customerResult = []
      this.$fetch.post('Partner/getCustomers', {
        page: this.customerPage,
        id:this.customerId,
      }, true).then(res => {
        this.customerResult = res.result
        this.customerPageCount = res.page
      })
    },
    timeChange(){
      this.detailPage = 1
      this.getDetailList()
    }
  }
}
</script>

<style scoped>
.this-page {
  padding: 10px;
  background-color: #FFFFFF;
}
</style>
